import Link from "next/link";
import { Col, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { HiMinusSm, HiHeart } from "react-icons/hi";
import { MdDeleteOutline } from "react-icons/md";
import { SubmitButton } from "../shared/input";
import FormSubmit from "../shared/submit";
import { IKImage } from "imagekitio-react";
import { Blob_Base_Url } from "../../utils/static";
import { wishListAction } from "../../utils/utility";

const CartItem = ({ data, updateItem, remove }) => {
  const { quantity, price, product, id } = data;
  const isProduct = product?.type === "Product";
  console.log(price);
  const duration = price.duration ? (
    <span className="font-lg text-blue mb-0">
      - {price.duration.days} days{" "}
      {price.duration.hours > 0 ? <>and {price.duration.hours} hrs</> : null}
    </span>
  ) : null;
  const maxStock = data.maxStock;

  const Update = (val, { target }) => {
    const newQuantity = quantity + val;
    if (newQuantity === 0) remove(data.id);
    else if (newQuantity > maxStock)
      toast.error("oops ! Only " + maxStock + " quantity available");
    else
      updateItem({
        id: data.id,
        quantity: val,
        productid: data.product.id,
      });
  };

  return (
    <div className="cart-item border-0">
      <div className="img-wrapper">
        <IKImage
          transformation={[
            {
              height: 130,
              width: 140,
              cropMode: "pad_resize",
            },
          ]}
          className="d-block w-100 rounded my-auto"
          urlEndpoint={Blob_Base_Url}
          path={data.product.id + "/0.jpg"}
        />
      </div>
      <Col>
        <div className="flex-between font-md">
          <p className="fw-bold mb-1">By : {data.product.brand}</p>
          {!isProduct ? <p className="fw-600 text-info">Rental</p> : ""}
        </div>
        <Link href={"/product/" + data.product.id}>
          <a href={"/product/" + data.product.id}>
            <h2 className="font-lg">{data.product.title}</h2>
          </a>
        </Link>

        {maxStock ? (
          <div className="d-flex">
            <Feature>
              <h4 className="font-sm mb-0">
                Delivery :{" "}
                <strong className="text-uppercase font-tiny text-dark">
                  {data.price.type?.replace("_", " ")}
                </strong>
              </h4>
            </Feature>
            {product?.type === "Product" ? (
              <Feature>
                <h4 className="font-sm mb-0">Qty :</h4>
                <div className="d-flex align-items-center ms-2">
                  {quantity > 1 ? (
                    <div
                      onClick={(e) => Update(-1, e)}
                      role="button"
                      className="fw-bold text-danger"
                    >
                      <HiMinusSm />
                    </div>
                  ) : null}

                  <span className="fw-bold px-2 font-lg">{quantity}</span>
                  <div
                    onClick={(e) => Update(1, e)}
                    role="button"
                    className="text-danger ps-1"
                  >
                    +
                  </div>
                </div>
              </Feature>
            ) : (
              <Feature>
                <strong>Mrp</strong>
                <span className="ms-2 fw-600 text-danger">$ {product.mrp}</span>
              </Feature>
            )}
            <Feature>
              <FormSubmit url={"/cart/remove/" + data.id} next="?refresh">
                <SubmitButton
                  title={
                    <MdDeleteOutline className="text-danger fw-600 fs-5" />
                  }
                  variant="light mt-0 mb-0 p-0"
                  color="danger"
                />
              </FormSubmit>
            </Feature>
          </div>
        ) : (
          <>
            <div className="d-flex">
              <Feature>
                <p className="text-center flex-between mb-0 mx-auto fw-600 text-danger">
                  Oops! not available
                </p>
              </Feature>
              <Feature>
                <FormSubmit
                  url={"/cart/remove/" + id}
                  next="?refresh=true"
                  callback={(_) => wishListAction("", product.id)}
                >
                  <SubmitButton
                    title={
                      <div className="d-flex ">
                        <HiHeart className="text-blue fs-6" />
                        <span className="ps-2 font-md text-secondary">
                          Move To Wishlist
                        </span>
                      </div>
                    }
                    color="primary"
                    variant="s fw-600 shadow-none p-0 mt-0 mb-0"
                  />
                </FormSubmit>
              </Feature>
            </div>
          </>
        )}
        <Row>
          <Col>
            <h2 className="rate">
              $ {data.price.amount} {duration}
            </h2>
          </Col>
          <Col xs="auto">
            {isProduct & (price.type === "Delivery") ? null : (
              <Link
                href={{
                  query: {
                    pId: price.id,
                    cId: id,
                    ...(isProduct
                      ? { pickup: product.id }
                      : { rental: product.id }),
                  },
                }}
              >
                <a className="font-md fw-600">
                  {isProduct ? "View Pickups" : "Change Duration"}
                </a>
              </Link>
            )}
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default CartItem;
//<Pickups id={data.id} /> : <RentalDuration />
const Feature = ({ children }) => (
  <div className="bg-light me-3 mb-3 d-flex align-items-center font-lg rounded-8 px-3 py-2">
    {children}
  </div>
);
